module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "thread-not-found"
  }, [_c('h1', [_vm._v("Oops! That thread doesn't exist.")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": _vm.linkToForum
    }
  }, [_vm._v("\n        Back to the forum\n    ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6a67ed86!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/reusable/forum/thread-not-found.vue
// module id = 2067
// module chunks = 2